// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fbGXI","image":"styles_image__IS671","hints":"styles_hints__2lxCQ","action":"styles_action__g0ykC"};